import { backgroundOrange, blackOrange, white } from "@/theme/colors";
import { fontDisplay } from "@/theme/fonts";
import styled from "styled-components";

export const GoogleButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 11px;
  width: 100%;
  padding: 15px 20px;
  background: ${white};
  border: 1.5px solid rgba(208, 95, 42, 0.2);
  border-radius: 14px;
  font-family: ${fontDisplay};
  font-weight: 700;
  font-size: 15.5px;
  color: ${blackOrange};
  transition:
    border-color 0.16s,
    background 0.16s,
    transform 0.16s;

  svg {
    width: 19px;
    height: 19px;
    flex: none;
  }

  &:hover {
    transform: none;
    border-color: rgba(208, 95, 42, 0.42);
    background: ${backgroundOrange};
  }

  &:active {
    transform: scale(0.985);
  }

  @media (prefers-reduced-motion: reduce) {
    transition: none;

    &:active {
      transform: none;
    }
  }
`;
